<template>
  <div>
    <el-form ref="businessForm" :model="businessForm" :rules="businessRules" label-width="100px" label-position="left">
      <el-card>
        <div slot="header" class="clearfix">
          <span>定制机型标签</span>
        </div>
        <el-row>
          <el-col :span="12">
            <el-form-item label="定制机型标签">
              <el-select v-model="customTag" class="form-select" @change="setCustomTagDirect">
                <el-option v-for="(item, index) in customTagList" :key="index" :value="item.adCustomTagId" :label="item.adCustomTagName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card v-if="excelInfo.channelIdList.length === 1" style="margin-top:10px">
        <div slot="header" class="clearfix">
          <span>定向包</span>
        </div>
        <el-row>
          <el-col :span="24">
            <el-form-item label="定向包">
              <div style="display:flex">
                <el-select v-model="directPackageId" filterable clearable class="form-select" @change="setDirectPackage">
                  <el-option v-for="(item, index) in directPackageOpts" :key="index" :value="item.directPackageId" :label="item.directPackageName"></el-option>
                </el-select>
                <span style="padding-left:12px;color: #969AA0;font-size:12px">
                  <i class="el-icon-warning"></i>
                  区域定向不会因定向包而修改
                </span>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <p class="card-nav">通用定向</p>
      <el-card>
        <div slot="header" class="clearfix">
          <span>设备定向</span>
        </div>
        <el-row>
          <el-col>
            <el-form-item label="尺寸定向">
              <div style="display: flex;">
                <el-radio-group v-model="deviceSizeData" @change="handleSizeChange">
                  <el-radio-button v-for="(item,index) in deviceSizeList" :label="item.value" :key="'s'+index">{{ item.label }}</el-radio-button>
                </el-radio-group>
              </div>
              <el-form :inline="true" :model="sizeForm" ref="sizeForm" :rules="sizeRules" v-if="deviceSizeData === '0'">
                <el-form-item prop="minSize">
                  <el-input class="demo-ruleForm-min-input" v-model="sizeForm.minSize" placeholder="最小尺寸" @change="clearPackage"></el-input>
                </el-form-item>-
                <el-form-item prop="maxSize">
                  <el-input class="demo-ruleForm-min-input" v-model="sizeForm.maxSize" placeholder="最大尺寸" @change="clearPackage"></el-input>
                </el-form-item>
              </el-form>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <el-card style="margin-top: 10px">
        <div slot="header" class="clearfix">
          <span>业务定向</span>
        </div>
        <el-row>
          <el-col :span="18">
            <CommonBusiness ref="bussiness" v-model="businessList" v-show="businessList.length > 0" @change="directPackageId = ''"></CommonBusiness>
          </el-col>
        </el-row>
      </el-card>
      <el-card style="margin-top: 10px" v-if="mediaTagList.length > 0">
        <div slot="header" class="clearfix">
          <span>场景定向</span>
        </div>
        <el-row>
          <el-col :span="18">
            <el-form-item label="场景标签">
              <CommonTreeSelectPannel :leftData="mediaTagList" v-model="mediaTags" :selectPanelColumns="['一级标签','二级标签','三级标签']"></CommonTreeSelectPannel>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <p class="card-nav">仅自有渠道</p>
      <el-card>
        <div slot="header" class="clearfix">
          <span>设备定向</span>
        </div>
        <el-row>
          <el-col :span="18">
            <el-form-item label="品牌机型">
              <el-radio-group v-model="brandType" :disabled="directional.isNeedBrands" @change="handleBrandTypeChange">
                <el-radio-button :label="0">不限</el-radio-button>
                <el-radio-button :label="1">选择品牌机型</el-radio-button>
              </el-radio-group>
              <template v-if="brandType === 1">
                <el-form-item prop="brandList">
                  <CommonSelectPannel
                    ref="barnd"
                    v-model="businessForm.brandList"
                    :leftData="availableBrandList"
                    :selectPanelColumns="['品牌','机型']"
                    @input="clearPackage"
                  ></CommonSelectPannel>
                </el-form-item>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item label="视频源定向">
              <el-checkbox-group v-model="videoSource" @change="handleChangeVideoSource">
                <el-checkbox-button :label="0">不限</el-checkbox-button>
                <el-checkbox-button v-for="item in videoSourceList" :label="item.value" :key="item.value">{{ item.label }}</el-checkbox-button>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>

      <el-card style="margin-top: 10px">
        <div slot="header" class="clearfix">
          <span>人群定向</span>
        </div>
        <el-row>
          <el-col :span="18">
            <el-form-item label="自定义标签">
              <el-radio-group v-model="customTagType" @change="hanldeChangeCustomTagType">
                <el-radio-button :label="0">不限</el-radio-button>
                <el-radio-button :label="1">MAC包</el-radio-button>
                <el-radio-button :label="3">LBS标签</el-radio-button>
              </el-radio-group>
              <template v-if="customTagType !== 0">
                <el-radio v-model="customMatchRule" label="in" style="margin-left: 20px;">定向所选标签</el-radio>
                <el-radio v-model="customMatchRule" label="notin">排除所选标签</el-radio>
                <template v-if="customTagType === 1">
                  <CommonSelectPannel :leftData="macTagList" v-model="macTags" :selectPanelColumns="['标签']" @input="clearPackage"></CommonSelectPannel>
                </template>
                <template v-if="customTagType === 3">
                  <CommonSelectPannel :leftData="lbsTagList" v-model="lbsTags" :selectPanelColumns="['标签']" @input="clearPackage"></CommonSelectPannel>
                </template>
              </template>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="DMP标签">
              <el-radio-group v-model="dmpMatchType" @change="handleChangeDmpSelectType">
                <el-radio-button :label="-1">不限</el-radio-button>
                <el-radio-button :label="1">任意匹配</el-radio-button>
                <el-radio-button :label="0">全部匹配</el-radio-button>
                <el-radio-button :label="2">排除</el-radio-button>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="dmpMatchType !== -1">
              <PopTableSelect v-model="policyName" :title="poper.title" :table="poper.table" @data-select="handleDmpSelect"></PopTableSelect>
            </el-form-item>
            <el-form-item v-if="policyName" prop="dmpTags">
              <CommonSelectPannel :leftData="dmpTagList" v-model="businessForm.dmpTags" :selectPanelColumns="['人群']" @input="clearPackage"></CommonSelectPannel>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="18">
            <el-form-item label="广告DMP">
              <el-radio-group v-model="crowdMatchType" @change="clearPackage">
                <el-radio-button :label="-1">不限</el-radio-button>
                <!--                      <el-radio-button :label="1">任意匹配</el-radio-button>-->
                <!--                      <el-radio-button :label="0">全部匹配</el-radio-button>-->
                <!--                      <el-radio-button :label="2">排除</el-radio-button>-->
                <el-radio-button :label="3">自定义</el-radio-button>
              </el-radio-group>
            </el-form-item>

<!--            <el-form-item label="广告DMP">-->
<!--              <el-radio-group v-model="crowdMatchType" @change="clearPackage">-->
<!--                <el-radio-button :label="-1">不限</el-radio-button>-->
<!--                <el-radio-button :label="1">任意匹配</el-radio-button>-->
<!--                <el-radio-button :label="0">全部匹配</el-radio-button>-->
<!--                <el-radio-button :label="2">排除</el-radio-button>-->
<!--              </el-radio-group>-->
<!--            </el-form-item>-->
            <el-form-item v-if="crowdMatchType !== -1">
              <CrowdSelectPannel
                :echoData="crowdEchoData"
                v-model="crowdIdList"
                ref="crowd"
                @selected="handleCrowdSelected"
              ></CrowdSelectPannel>
<!--              <CommonLazySelect-->
<!--                v-model="crowdIdList"-->
<!--                serviceName="getDmpCrowds"-->
<!--                :multiple="true"-->
<!--                :filter="{-->
<!--                  crowdNameId: ''-->
<!--                }"-->
<!--                :primaryKey="{}"-->
<!--                :optionsMap="{-->
<!--                  key: 'crowdTagId',-->
<!--                  label: 'crowdName'-->
<!--                }"-->
<!--                :isNoLableClean="true"-->
<!--                :echoData="crowdEchoData"-->
<!--                @selected="handleCrowdSelected"-->
<!--              ></CommonLazySelect>-->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isOwn">
          <el-col>
            <el-form-item label="三方DMP">
              <el-radio-group v-model="thirdDmpId" @change="handleThirdDmpChange">
                <el-radio-button :label="-1">不限</el-radio-button>
                <el-radio-button v-for="(item, index) in thirdDmpOptions" :key="index" :label="item.dmpId">{{ item.partnersName }}</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col v-if="thirdDmpId !== -1" :span="18">
            <CommonBusiness ref="thirdDmp" v-model="dmpComponentList" @change="directPackageId = ''"></CommonBusiness>
          </el-col>
        </el-row>
      </el-card>

      <el-card v-if="excelInfo.channelIdList.length === 1" style="margin-top:10px">
        <el-row>
          <el-col>
            <el-form-item label="存为定向包" prop="directPackageName" style="margin-bottom:0">
              <div class="flex-form-item">
                <el-radio-group v-model="businessForm.directPackageSave" @change="businessForm.directPackageName === ''">
                  <el-radio-button :label="0">否</el-radio-button>
                  <el-radio-button :label="1">是</el-radio-button>
                </el-radio-group>
                <template v-if="businessForm.directPackageSave === 1">
                  <el-input
                    v-model="businessForm.directPackageName"
                    clearable
                    show-word-limit
                    maxlength="25"
                    style="margin:0 10px;width:400px"
                    placeholder="请输入定向包名称"
                  ></el-input>
                  <span style="padding-left:12px;color: #969AA0;font-size:12px">
                    <i class="el-icon-warning"></i>
                    区域定向不会因定向包而修改
                  </span>
                </template>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-card>
      <ScheduleExtendParam
        ref="scheduleExtendParam"
        :scheduleIds="scheduleIds"
        :template-list="templateList"
        :schedules="scheduleList"
        :clockAmountFlag="model.clockAmountFlag"
        :orderId="value ? value.orderId : 0"
        @refresh="$emit('refresh', true)"
      />
    </el-form>
    <el-card style="margin-top: 10px">
      <el-button @click="previous()">上一步</el-button>
      <el-button :loading="buttonSaveLoading" @click="save(0)">保存草稿</el-button>
      <el-button :loading="buttonSubmitLoading" type="primary" @click="save(1)">提交送审</el-button>
    </el-card>
  </div>
</template>
<script>
import CommonSelectPannel from '@/components/scheduleDirection/CommonSelectPannel'
import CommonBusiness from '@/components/scheduleDirection/CommonBusiness'
import CommonTreeSelectPannel from '@/components/scheduleDirection/CommonTreeSelectPannel'
import PopTableSelect from '@/components/common/PopTableSelect'
import CrowdSelectPannel from '@/components/scheduleDirection/CrowdSelectPannel'
import ScheduleExtendParam from './ScheduleExtendParam.vue'

import useSpaceComponent from '@/hooks/useSpaceComponent'
import { handleReviewPannelData, handleReviewDmp, handleBrand } from '@/components/schedule/utils'

export default {
  components: {
    CommonSelectPannel,
    CommonBusiness,
    CommonTreeSelectPannel,
    PopTableSelect,
    CrowdSelectPannel,
    ScheduleExtendParam
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    excelInfo: {
      type: Object,
      default: () => ({ channelIdList: [] })
    },
    adSpaceModel: {
      type: Object,
      default: () => ({})
    }
  },
  watch: {
    excelInfo(newValue, oldValue) {
      if (newValue && newValue.spaceId) {
        if (this.preSpaceId !== this.value.spaceId) {
          this.getDirectPackages()
          this.getScheduleDirect()
          this.getThirdDmpList().then(res => {
            this.handleThirdDmp(true)
          })
        }
      }
      if (this.value.spaceId) {
        this.$service.getSpace().then(data => {
          let space = data.spaceList.find(item => item.spaceId === this.value.spaceId)
          if (space.spaceNo === 'CCADTV10004') {
            this.getMediaTags()
          }
        })
        this.getBrandList()
      }
      const rightForm = document.getElementById('rightForm')
      if (rightForm) {
        rightForm.scrollTop = 0
      }
    }
  },
  data() {
    var validateMinSize = (rule, value, callback) => {
      if (value) {
        const regx = /^[1-9]\d*$/
        if (!regx.test(value)) {
          callback(new Error('最小尺寸必须为大于0的整数'))
        } else {
          if (Number(value) < 200 && Number(value) > 0) {
            if (!this.isOwn && Number(value) < 50) {
              return callback(new Error('最小尺寸不能低于50'))
            }
            if (this.sizeForm.maxSize) {
              if (Number(value) >= Number(this.sizeForm.maxSize)) {
                callback(new Error('最小尺寸必须小于最大尺寸'))
              } else {
                callback()
              }
            } else {
              callback()
            }
          } else if (Number(value) >= 200) {
            callback(new Error('最小尺寸必须小于200'))
          } else {
            callback()
          }
        }
      } else {
        callback(new Error('自定义条件下，最小尺寸必填'))
      }
    }
    var validateMaxSize = (rule, value, callback) => {
      if (value) {
        const regx = /^[1-9]\d*$/
        if (!regx.test(value)) {
          callback(new Error('最大尺寸必须为大于0的整数'))
        } else {
          if (Number(value) <= 200 && Number(value) > 0) {
            if (this.sizeForm.minSize) {
              if (Number(value) <= Number(this.sizeForm.minSize)) {
                callback(new Error('最大尺寸必须大于最小尺寸'))
              } else {
                callback()
              }
            }
          } else if (Number(value) > 200) {
            callback(new Error('最大尺寸不能超过200'))
          } else {
            callback()
          }
        }
      } else {
        callback(new Error('自定义条件下，最大尺寸必填'))
      }
    }
    var validateBrandList = (rule, value, callback) => {
      // 需要选择品牌
      if (this.directional.isNeedBrands) {
        if (value.length === 0) {
          callback(new Error('未设置品牌机型定向'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    var checkDmpTags = (rule, value, callback) => {
      if (this.policyName && value && value.length === 0) {
        return callback(new Error('请选择人群'))
      }
      callback()
    }
    var checkPackageName = (rule, value, callback) => {
      if (this.businessForm.directPackageSave === 0) {
        return callback()
      }
      if (!value) {
        return callback(new Error('请输入定向包名称'))
      }
      this.$service.checkDirectPackageName({ directPackageName: value }).then(res => {
        if (res === 1) {
          callback(new Error('定向包名称已存在，请重新输入'))
        } else {
          callback()
        }
      })
    }
    return {
      scheduleIds: [], // 送审Id
      directional: {},
      businessList: [], // 业务定向
      preSpaceId: 0,
      mediaTagList: [], // 场景定向标签
      templateList: [],
      deviceSizeData: '-1', // 默认尺寸数据
      deviceSizeList: [],
      sizeForm: {
        minSize: undefined,
        maxSize: undefined
      },
      sizeRules: {
        minSize: [{ validator: validateMinSize, trigger: 'blur' }],
        maxSize: [{ validator: validateMaxSize, trigger: 'blur' }]
      },
      brandType: 0,
      brandsModelsList: [], // 品牌数据
      businessForm: {
        brandList: [],
        dmpTags: [],
        directPackageSave: 0,
        directPackageName: ''
      },
      businessRules: {
        brandList: [{ type: 'array', validator: validateBrandList, trigger: 'change' }],
        dmpTags: [{ validator: checkDmpTags, trigger: 'blur' }],
        directPackageName: [{ validator: checkPackageName, trigger: 'blur' }]
      },
      videoSource: [0],
      videoSourceList: [], // 视频源
      dmpMatchType: -1, // dmp标签
      policyId: undefined,
      policyName: '',
      dmpTagList: [], // dmp
      crowdMatchType: -1, // 广告DMP
      crowdIdList: [],
      crowdEchoData: [],
      customTagType: 0, // 自定义标签
      customMatchRule: 'in',
      lbsTagList: [], // lbs标签
      macTagList: [], // mac标签
      macTags: [], // mac包标签
      lbsTags: [], // lbs标签
      mediaTags: [], // 媒资标签
      customTag: '',
      customTagList: [],
      directPackageId: '', // 定向包
      directPackageOpts: [],
      model: {
        fileName: '',
        scheduleId: undefined,
        orderId: undefined,
        schedulingId: undefined, // 排期id
        planType: 0,
        scheduleSource: undefined,
        supportMode: undefined,
        payment: '0', // 结算方式
        trafficSpeed: 1,
        spaceId: undefined,
        deviceSizeList: [], // 尺寸定向
        devices: [], // 品牌，机型，视频源定向
        customMatchRule: 'in',
        adScheduleVideoTags: [], // 场景定向
        businessSettingList: [], // 业务定向
        customLbsList: [], // 自定义lbs标签
        customMacTagList: [], // 自定义mac标签
        customModelsList: [], // 自定义机型标签
        dmpList: [], // dmp人群标签
        regionList: [],
        clockAmountFlag: 0,
        cableChannelList: [],
        crowdList: []
      },
      buttonSaveLoading: false,
      buttonSubmitLoading: false,
      poper: {
        title: '添加人群',
        table: {
          props: {
            border: true,
            'tooltip-effect': 'dark',
            'row-style': { height: '40px' },
            'cell-style': { padding: '0' },
            'max-height': 400
          },
          header: [
            {
              label: 'ID',
              align: 'left',
              prop: 'policyId',
              width: 100,
              'show-overflow-tooltip': true
            },
            {
              label: '人群策略名称',
              align: 'left',
              prop: 'policyName',
              query: true,
              placeholder: '请输入人群策略名称',
              'min-width': 100,
              'show-overflow-tooltip': true
            },
            {
              label: '创建时间',
              align: 'left',
              prop: 'createTime',
              'min-width': 100,
              'show-overflow-tooltip': true
            }
          ],
          api: this.$service.getDmpPolicyList
        }
      },
      thirdDmpId: -1,
      thirdDmpOptions: [],
      dmpComponentList: [],
      scheduleList: [],
      backupSize: '-1'
    }
  },
  computed: {
    // 选择自有投放渠道后，过滤品牌机型
    availableBrandList() {
      return handleBrand(this.brandsModelsList)
    },
    isOwn() {
      return this.excelInfo.channelIdList.includes('skyworth_market') || this.excelInfo.channelIdList.includes('coocaa_market')
    }
  },
  mounted() {
  },
  methods: {
    // 获取定向条件
    getScheduleDirect() {
      this.buttonSaveLoading = true
      this.buttonSubmitLoading = true
      this.$service.getScheduleDirect({ orderId: this.value.orderId }).then(data => {
        this.buttonSaveLoading = false
        this.buttonSubmitLoading = false
        this.directional = data
        // 需要勾选品牌,并且不能选择不限
        if (this.directional.isNeedBrands) {
          this.brandType = 1
        }
        this.businessList = []
        this.handleBusiness(true)
        this.handleThirdDmp()
        let arr = []
        if (!this.isOwn) {
          arr = data.deviceSizeList.filter(item => !item.dictLabel.includes('0-49'))
        } else {
          arr = data.deviceSizeList
        }
        this.deviceSizeList = this.handleDeviceSize(arr)
        this.videoSourceList = data.videoSourceList
          .filter(item => item.tag !== 'voole')
          .map(item => {
            return {
              label: item.tag,
              value: item.tagDeviceId
            }
          })
        this.customTagList = this.directional.scheduleTagCustomList || []
        this.macTagList = data.macTagList.map(item => {
          return {
            label: item.adCustomTagName,
            value: item.adCustomTagId
          }
        })
        this.lbsTagList = data.lbsTagList.map(item => {
          return {
            label: item.circleName,
            value: item.tagId
          }
        })
        this.templateList = data.templateList || []
      })
    },
    // 切换自定义标签
    hanldeChangeCustomTagType() {
      this.macTags = []
      this.lbsTags = []
      this.clearPackage()
    },
    // 切换DMP类型
    handleChangeDmpSelectType() {
      this.policyId = undefined
      this.policyName = ''
      this.businessForm.dmpTags = []
      this.clearPackage()
    },
    // 尺寸格式化
    handleDeviceSize(data) {
      let options = data.map(item => {
        return {
          label: item.dictLabel,
          value: item.dictValue,
          dictSort: item.dictSort
        }
      })
      const deleteValue = options.shift()
      options.unshift({
        value: '-1',
        label: '不限',
        dictSort: 100
      })
      options.push(deleteValue)
      return options
    },
    handleBrand(data) {
      let brandModelsData = []
      const brandModelsList = data
      brandModelsList.forEach(element => {
        if (element.parent === 1) {
          brandModelsData.push({
            label: element.tag,
            value: element.tagDeviceId,
            children: []
          })
        }
      })
      for (let i = 0; i < brandModelsData.length; i++) {
        for (let j = 0; j < brandModelsList.length; j++) {
          if (brandModelsList[j].parent === brandModelsData[i].value) {
            brandModelsData[i].children.push({
              value: brandModelsList[j].tagDeviceId,
              label: brandModelsList[j].tag
            })
          }
        }
      }
      return brandModelsData
    },
    handleChangeVideoSource() {
      const index = this.videoSource.findIndex(item => item === 0)
      const length = this.videoSource.length
      this.clearPackage()
      if ((index === 0 && length < 1) || index === length - 1) {
        this.videoSource = [0]
      } else {
        this.videoSource = this.videoSource.filter(item => item !== 0)
      }
    },
    // 广告位业务定向相关
    handleBusiness(isSetDefault) {
      if (this.directional.spaceList.some(item => item.spaceId === this.value.spaceId)) {
        const { setBusinessComponents } = useSpaceComponent()
        const adSpaceComponentEntityList = this.directional.spaceList.find(item => item.spaceId === this.value.spaceId).adSpaceComponentEntityList
        this.businessList = setBusinessComponents(adSpaceComponentEntityList, this.businessList, isSetDefault)
      }
    },
    // 三方dmp
    handleThirdDmp(isSetDefault) {
      if (this.thirdDmpId === -1) {
        this.dmpComponentList = []
      }
      const { setBusinessComponents } = useSpaceComponent()
      const thirdDmp = this.thirdDmpOptions.find(item => item.dmpId === this.thirdDmpId)
      const dmpComponents = thirdDmp ? thirdDmp.dmpComponentList : []
      dmpComponents.sort((prev, next) => {
        return prev.componentSeq - next.componentSeq
      })
      this.dmpComponentList = setBusinessComponents(dmpComponents, this.dmpComponentList, isSetDefault)
    },
    previous() {
      this.preSpaceId = this.value.spaceId
      this.$emit('previous', 1)
    },
    // 获取媒资标签
    getMediaTags() {
      this.$service.getMediaTags().then(data => {
        this.mediaTagList = data
      })
    },
    // 根据投放渠道/erp素材时长/是否程序化/广告位/尺寸 获取支持的品牌机型
    getBrandList() {
      if (!this.excelInfo.spaceNo) {
        return
      }
      const params = {
        planType: this.value.planType,
        sizeTarget: this.deviceSizeData === '-1' ? 0 : 1,
        spaceNo: this.excelInfo.spaceNo
      }
      return this.$service.getBrandList(params).then(res => {
        this.brandsModelsList = res || []
      })
    },
    // 保存之前处理业务定向
    handleScheduleDirection() {
      // 选择mac定向后，地区，尺寸，人群，自定义标签，机型品牌视频源不传给接口
      // if (this.showOtherDirection) {
      this.model.deviceSizeList = this.handleFormDeviceSizeList(this.deviceSizeData)
      this.model.dmpList = this.handleFormDmpList()
      this.model.devices = this.handleFormDevices()
      if (this.mediaTags.length > 0) {
        this.model.adScheduleVideoTags = this.handleFormMediaTags(this.mediaTags)
      }
      // mac标签
      this.model.customMacTagList = this.customTagType === 1 ? this.macTags.map(item => item.value) : []
      // lbs
      this.model.customLbsList = this.customTagType === 3 ? this.lbsTags.map(item => item.value) : []
      // 业务定向
      this.model.businessSettingList = this.handleFormBussiness(this.businessList)
      // 三方dmp
      this.model.thridDmpList = this.handleFormBussiness(this.dmpComponentList, 'dmp')
    },
    // 处理业务定向
    handleFormBussiness(data = [], type) {
      const { buildBusinessValue } = useSpaceComponent()
      const result = data.map(item => {
        return {
          componentId: item.componentId,
          componentKey: item.componentKey,
          componentType: item.componentType,
          componentMatchType: item.componentMatchType,
          componentValue: buildBusinessValue(item),
          dmpId: type === 'dmp' ? this.thirdDmpId : undefined
        }
      }).filter(e => e.componentValue)
      return result
    },
    save(type) {
      const validateArr = []
      validateArr.push(
        new Promise((resolve, reject) => {
          this.$refs.businessForm.validate(valid => {
            if (valid) resolve()
          })
        })
      )

      if (this.$refs.bussiness) {
        validateArr.push(
          new Promise((resolve, reject) => {
            this.$refs.bussiness.$refs.form.validate(valid => {
              if (valid) resolve()
            })
          })
        )
      }

      if (this.$refs.thirdDmp) {
        validateArr.push(
          new Promise((resolve, reject) => {
            this.$refs.thirdDmp.$refs.form.validate(valid => {
              if (valid) resolve()
            })
          })
        )
      }

      if (this.$refs.sizeForm) {
        validateArr.push(
          new Promise((resolve, reject) => {
            this.$refs.sizeForm.validate(valid => {
              if (valid) resolve()
            })
          })
        )
      }

      Promise.all(validateArr).then(res => {
        this.saveForm(type)
      })
    },
    saveForm(type) {
      this.buttonSaveLoading = type !== 1
      this.buttonSubmitLoading = type === 1
      this.handleScheduleDirection()
      let formData = JSON.parse(JSON.stringify(this.model))
      formData.orderId = this.value.orderId
      formData.trackType = this.value.trackType
      formData.batchTimeList = this.value.batchTimeList.map(item => {
        return {
          sheetType: item.sheetType,
          dateType: item.dateType,
          timeList: item.timeList
        }
      })
      formData.fileName = this.value.fileName
      formData.schedulingId = this.value.schedulingId
      formData.planType = this.value.planType
      formData.receivePct = parseInt(this.value.receivePct)
      formData.scheduleSource = this.value.scheduleSource // f
      formData.supportMode = this.value.supportMode
      formData.payment = parseInt(this.value.payment) // g
      formData.trafficSpeed = this.value.trafficSpeed // g
      formData.spaceId = this.value.spaceId
      formData.clockAmountFlag = type
      formData.customMatchRule = this.customMatchRule
      formData.cableChannelList = this.value.cableChannelList
      formData.dmpMatchType = this.dmpMatchType === -1 ? undefined : this.dmpMatchType
      formData.crowdMatchType = this.crowdMatchType === -1 ? undefined : this.crowdMatchType
      formData.crowdList = this.crowdMatchType === -1 ? [] : formData.crowdList
      formData.productPremium = this.value.productPremium
      formData.pvRate = this.value.pvRate
      formData.exposurePct = this.value.exposurePct
      formData.scheduleSub = {
        exposureDirectly: (this.adSpaceModel && this.adSpaceModel.supportInterestTag === 1) ? this.value.exposureDirectly : undefined,
        checkExposurePct: this.excelInfo.checkExposurePct,
        addExposurePct: this.excelInfo.addExposurePct
      }
      formData.feedContent = (this.adSpaceModel && this.adSpaceModel.supportFeedContent === 1)
        ? {
          creativeTitle: this.value.creativeTitle,
          clickButtonContent: this.value.shipType === 'KEY' ? this.value.clickButtonContent : undefined
        }
        : undefined
      formData.ctr = this.value.ctr ? parseInt(this.value.ctr, 10) : 0
      formData.iesSwitch = this.value.iesSwitch
      formData.keyEventList = this.excelInfo.targetEvent === 1 ? this.value.keyEventList : undefined
      formData.autoEventList = this.excelInfo.targetEvent === 1 ? this.value.autoEventList : undefined
      formData.voiceEventList = this.excelInfo.targetEvent === 1 ? this.value.voiceEventList : undefined
      formData.isExtendParams = this.value.extendParamType
      formData.tipsTempId = this.value.tipsTempId !== undefined ? this.value.tipsTempId : undefined
      formData.tipsDetail = this.value.tipsDetail ? this.value.tipsDetail : undefined
      formData.directPackageSave = this.businessForm.directPackageSave
      formData.directPackageName = (this.excelInfo.channelIdList.length === 1 && this.businessForm.directPackageSave === 1) ? this.businessForm.directPackageName : undefined
      const exsitBackupEvent = this.excelInfo.targetEvent === 1 && this.value.supportMode === 2
      formData.backupKeyEventList = exsitBackupEvent ? this.value.backupKeyEventList : undefined
      formData.backupVoiceEventList = exsitBackupEvent ? this.value.backupVoiceEventList : undefined
      formData.backupAutoEventList = exsitBackupEvent ? this.value.backupAutoEventList : undefined
      // 判断是否有N+UV
      const msg = type === 1 ? '送审成功!' : '保存成功!'
      this.$service
        .saveBatchSchedule(formData)
        .then(data => {
          this.buttonSaveLoading = false
          this.buttonSubmitLoading = false
          this.scheduleIds = data.scheduleIds || []
          if (this.value.extendParamType === 1) {
            this.model.clockAmountFlag = type
            this.$refs.scheduleExtendParam.showExtendParam = true
            this.scheduleList = data.scheduleExtendParamList
          } else {
            // 判断是否N+UV 跳转到其他配置
            this.scheduleIds = data.scheduleIds
            if (this.scheduleIds && this.scheduleIds.length) {
              this.$parent.$parent.active = 3
              return
            }
            this.$notify({ title: '操作成功', message: msg, type: 'success' })
            this.$emit('refresh', true)
          }
        })
        .catch(() => {
          this.buttonSaveLoading = false
          this.buttonSubmitLoading = false
        })
    },
    handleFormDevices() {
      let devicesData = this.videoSource.filter(item => item && item !== 0)
      this.businessForm.brandList.forEach(item => {
        if (item.children) {
          // 全选了品牌
          devicesData.push(item.value)
        } else {
          // 选了品牌下的部分机型
          devicesData.push(item.value)
        }
      })
      return devicesData
    },
    // 选择了dmp策略
    handleDmpSelect(rowData) {
      this.policyId = rowData.policyId
      this.policyName = rowData.policyName
      this.businessForm.dmpTags = []
      this.getCrowdList(rowData.policyId)
      this.clearPackage()
    },
    // 根据策略id获取人群标签
    getCrowdList(policyId) {
      return new Promise((resolve, reject) => {
        if (!policyId) {
          this.dmpTagList = []
          resolve()
        }
        this.$service.getCrowdList({ policyId: policyId }).then(res => {
          this.dmpTagList = (res || []).map(item => {
            return {
              label: item.text,
              value: item.crowdId
            }
          })
          resolve()
        })
      })
    },
    handleFormDmpList() {
      let dmpData = []
      this.businessForm.dmpTags.forEach(item => {
        dmpData.push({
          policyId: this.policyId,
          policyName: this.policyName,
          crowdId: item.value,
          text: item.label
        })
      })
      return dmpData
    },
    // 处理尺寸定向
    handleFormDeviceSizeList(data) {
      if (data === '-1') {
        return undefined
      } else if (data === '0') {
        const str = this.sizeForm.minSize + '-' + this.sizeForm.maxSize
        const obj = {
          dictSort: 0,
          dictValue: str.toString()
        }
        return [obj]
      } else {
        const obj = {
          dictSort: this.deviceSizeList.filter(item => item.value === data)[0].dictSort,
          dictValue: data
        }
        return [obj]
      }
    },
    // 处理场景标签
    handleFormMediaTags(data) {
      const videoList = []
      data.forEach(item => {
        if (item.classType && item.pkgId) {
          // 选择的是三级
          videoList.push({
            classType: item.classType,
            classTypeName: item.classTypeName,
            pkgId: item.pkgId,
            pkgName: item.pkgName,
            classId: item.val,
            className: item.key
          })
        } else if (item.classType && !item.pkgId) {
          // 选择的是二级
          videoList.push({
            classType: item.classType,
            classTypeName: item.classTypeName,
            pkgId: item.val,
            pkgName: item.key
          })
        } else {
          // 选择的是一级
          videoList.push({
            classType: item.val,
            classTypeName: item.key
          })
        }
      })
      return videoList
    },
    getThirdDmpList() {
      return new Promise((resolve, reject) => {
        const params = { status: 1 }
        this.$service.getThirdDmpList(params).then(res => {
          this.thirdDmpOptions = res
          resolve()
        })
      })
    },
    handleThirdDmpChange(val) {
      this.dmpComponentList = []
      this.handleThirdDmp(true)
      this.clearPackage()
    },
    handleCrowdSelected(val) {
      this.model.crowdList = val.map(item => {
        return {
          crowdTagId: item.crowdTagId,
          crowdName: item.crowdName,
          crowdSource: item.crowdSource,
          matchType: item.matchType
        }
      })
      this.clearPackage()
    },
    // 选择的机型标签回显到品牌机型、区域、尺寸、视频源定向
    setCustomTagDirect(tagId) {
      const customTag = this.customTagList.find(item => item.adCustomTagId === tagId)
      if (!customTag) {
        return
      }
      this.directPackageId = ''
      if (customTag.modelList && customTag.modelList.length) {
        const brandKeyObj = this.brandsModelsList.reduce((prev, cur) => {
          prev[cur.tagDeviceId] = cur.tag
          return prev
        }, {})
        this.brandType = 1
        const brandList = []
        this.businessForm.brandList = []
        customTag.modelList.forEach(item => {
          const hasPermission = brandKeyObj[item.id]
          if (hasPermission) {
            brandList.push({
              value: item.id,
              label: item.name
            })
          }
        })
        this.businessForm.brandList = brandList
      }
      if (customTag.size) {
        const sizeExist = this.deviceSizeList.find(item => item.value === customTag.size)
        if (sizeExist) {
          this.deviceSizeData = customTag.size
        } else {
          this.deviceSizeData = '0'
          this.sizeForm.minSize = customTag.size.split('-')[0]
          this.sizeForm.maxSize = customTag.size.split('-')[1]
        }
      }
      if (customTag.tvSources && customTag.tvSources.length) {
        this.videoSource = customTag.tvSources
      }
      this.$nextTick(() => {
        this.customTag = tagId
      })
    },
    getDirectPackages() {
      if (this.excelInfo.channelIdList.length !== 1 || !this.value.spaceId) {
        return
      }
      const params = {
        channelId: this.value.channelId,
        spaceId: this.value.spaceId
      }
      this.$service.getDirectPackages(params).then(res => {
        this.directPackageOpts = res || []
      })
    },
    setDirectPackage(val) {
      if (!val) {
        return
      }
      this.customTag = ''
      this.$service.getDirectPackageDetail({ directPackageId: val }).then(res => {
        this.renderDirectPackage(res.packageDetailData || {})
      })
    },
    renderDirectPackage(directData) {
      // 尺寸
      if (directData.deviceSizeList && directData.deviceSizeList.length) {
        this.deviceSizeData = this.handleReviewSizeData(directData.deviceSizeList)
      }
      // 设备、视频源
      this.getBrandList().then(() => {
        if (directData.devices && directData.devices) {
          this.handleReviewDevice(directData.devices)
        }
      })
      // 自定义标签
      if (directData.customMacTagList && directData.customMacTagList.length) {
        this.customTagType = 1
        this.macTags = handleReviewPannelData(this.macTagList, directData.customMacTagList)
        this.customMatchRule = directData.customMatchRule === 'notin' ? 'notin' : 'in'
      } else if (directData.customLbsList && directData.customLbsList.length > 0) {
        this.customTagType = 3
        this.lbsTags = handleReviewPannelData(this.lbsTagList, directData.customLbsList)
        this.customMatchRule = directData.customMatchRule === 'notin' ? 'notin' : 'in'
      }
      // DMP标签
      if (directData.adScheduleDmps && directData.adScheduleDmps.length) {
        this.dmpMatchType = directData.adScheduleDmps[0].matchType
        this.policyId = directData.adScheduleDmps[0].policyId
        this.policyName = directData.adScheduleDmps[0].policyName
        this.getCrowdList(directData.adScheduleDmps[0].policyId).then(res => {
          this.businessForm.dmpTags = handleReviewDmp(this.dmpTagList, directData.adScheduleDmps)
        })
      }
      this.crowdMatchType = directData.crowdMatchType || -1
      // 广告DMP
      if (directData.adScheduleCrowds && directData.adScheduleCrowds.length) {
        // this.crowdMatchType = directData.adScheduleCrowds[0].matchType
        this.crowdMatchType = directData.crowdMatchType
        this.crowdIdList = []
        this.crowdEchoData = []
        this.model.crowdList = directData.adScheduleCrowds.map(item => {
          this.crowdEchoData.push({
            value: item.crowdTagId,
            label: item.crowdName,
            ...item
          })
          this.crowdIdList.push(item.crowdTagId)
          return {
            crowdTagId: item.crowdTagId,
            crowdName: item.crowdName,
            matchType: item.matchType
          }
        })
      }
      // 业务定向
      if (directData.adScheduleBusinessSettings && directData.adScheduleBusinessSettings.length) {
        this.businessList = directData.adScheduleBusinessSettings
        this.handleBusiness()
      }
      // 三方DMP
      if (directData.thirdDmpEntityList && directData.thirdDmpEntityList.length) {
        this.dmpComponentList = directData.thirdDmpEntityList || []
        this.thirdDmpId = this.dmpComponentList.length ? this.dmpComponentList[0].dmpId : -1
        this.handleThirdDmp()
      }
    },
    handleReviewSizeData(data) {
      // 这里要回显尺寸，不等于接口的尺寸，就是自定义
      if (data.length === 0) {
        // 没有尺寸就是不限
        return '-1'
      } else if (data[0].dictSort === 0) {
        const sizeValue = data[0].dictValue.split('-')
        this.sizeForm.minSize = sizeValue[0]
        this.sizeForm.maxSize = sizeValue[1]
        return '0'
      } else {
        return data[0].dictValue
      }
    },
    handleReviewDevice(data) {
      if (data) {
        let devices = data
        this.businessForm.brandList = handleReviewPannelData(this.availableBrandList, devices)
        this.videoSource = []
        this.videoSourceList.forEach(item => {
          devices.forEach(element => {
            if (item.value === element) {
              this.videoSource.push(element)
            }
          })
        })
        if (this.businessForm.brandList.length > 0) {
          this.brandType = 1
        }
        // 如果没有选择视频源默认不限
        if (this.videoSource.length === 0) {
          this.videoSource = [0]
        }
      }
    },
    handleSizeChange(val) {
      this.sizeForm.minSize = undefined
      this.sizeForm.maxSize = undefined
      this.clearPackage()
      // 尺寸从不限改为其他，或其他改为不限，重新查询品牌
      if ((this.backupSize === '-1' && val !== '-1') || (this.backupSize !== '-1' && val === '-1')) {
        this.businessForm.brandList = []
        this.getBrandList()
      }
      this.backupSize = val
    },
    handleBrandTypeChange() {
      this.businessForm.brandList = []
      this.clearPackage()
    },
    clearPackage() {
      this.customTag = ''
      this.directPackageId = ''
    }
  }
}
</script>
<style lang="stylus" scoped>
.demo-ruleForm-min-input >>>.el-input__inner
  border none
  border-bottom 1px solid #dcdfe6
  border-radius 0
.card-nav
  padding 0 10px
  font-weight bold
  margin 20px 0 12px
.el-radio-button >>>.el-radio-button__inner
  min-width 80px
.form-select
  width 390px
.flex-form-item
  display flex
</style>
